/**
 * ./src/modules/product/hooks/useGridLayout.ts
 *
 * useGridLayout hook
 *
 * @since 12/09/2024
 * @copyright DesignShop, 2024
 */
import { useQueryParams } from '@/modules/common/hooks/useQueryParams';

const useGridLayout = () => {
  const [gridLayout, setGridLayout] = useQueryParams<'thumbnail' | 'side-by-side' | null>(
    'grid',
    'side-by-side'
  );

  return {
    gridLayout,
    setGridLayout,
  };
};

export default useGridLayout;
